import { CircularProgress } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import _ from "lodash";
import React, { useEffect, useState } from "react";

import TaskToolTip from "./taskToolTip";
import HelperText from "../../../../../../components/feedback/helper-text/";
import { getfieldPropertie, getUnitPropertie } from "../../functions";
import { parseUrlConfig } from "../util/parseUrlConfig";
import { shouldDisableField } from "../util/shouldDisableField";

function TaskFieldSelect(props) {
  const { fieldProperties, form } = props;

  const [apiIsLoading, setApiIsLoading] = useState(false);

  const waitVariables = getUnitPropertie(fieldProperties, "waitVariables");
  const waitVariablesOptions = getUnitPropertie(
    fieldProperties,
    "waitVariablesOptions",
  );
  const urlConfigOptions = getfieldPropertie(fieldProperties, "options");

  const isFieldDisabled = shouldDisableField(
    waitVariables,
    waitVariablesOptions,
    form,
  );
  const urlConfigParsed = parseUrlConfig(urlConfigOptions, form);

  const getOptions = (_options) => {
    const options = [];
    const { fieldProperties, form } = props;

    const isApiOrVariableType =
      _options && (_options.type === "variable" || _options.type === "api");

    const variableName =
      isApiOrVariableType && getUnitPropertie(fieldProperties, "variableName");
    const jsonFieldValue =
      isApiOrVariableType &&
      getUnitPropertie(fieldProperties, "jsonFieldValue");
    const jsonFieldText =
      isApiOrVariableType && getUnitPropertie(fieldProperties, "jsonFieldText");
    let jsonProcessVariableList = [];

    // converte a variavel do processo para json
    if (isApiOrVariableType) {
      const processVariableList =
        (isApiOrVariableType &&
          form &&
          form.values &&
          form.values[variableName]) ||
        "[]";
      try {
        jsonProcessVariableList = JSON.parse(processVariableList);
      } catch (err) {
        console.error(err);
      }
    }

    _options &&
      _options.type === "api" &&
      urloptions &&
      urloptions.length &&
      urloptions.map &&
      urloptions.map((option) => {
        const valueField = jsonFieldValue
          ? option[jsonFieldValue]
          : option.value;
        const textField = jsonFieldText ? option[jsonFieldText] : option.text;

        return options.push(
          <MenuItem key={valueField} value={valueField}>
            {textField}
          </MenuItem>,
        );
      });

    _options &&
      _options.type === "options" &&
      _options.value.map((option) => {
        return (
          option &&
          options.push(
            <MenuItem key={option.key} value={option.value}>
              {option.text}
            </MenuItem>,
          )
        );
      });

    _options &&
      _options.type === "variable" &&
      Array.isArray(jsonProcessVariableList) &&
      jsonProcessVariableList.map((option) => {
        const valueField = jsonFieldValue
          ? option[jsonFieldValue]
          : option.value;
        const textField = jsonFieldText ? option[jsonFieldText] : option.text;
        return options.push(
          <MenuItem key={valueField} value={valueField}>
            {textField}
          </MenuItem>,
        );
      });

    return options;
  };

  const handleOnChange = (event, data) => {
    const { fieldProperties, onChange } = props;
    const id = fieldProperties && fieldProperties.id;
    onChange && onChange(id, event.target.value);
  };

  const handleOnBlur = (event) => {
    const { fieldProperties, OnBlur } = props;
    const id = fieldProperties && fieldProperties.id;
    OnBlur && OnBlur(id, event.target.value, fieldProperties);
  };

  const [urloptions, setUrlOptions] = useState([]);
  useEffect(() => {
    const fetchApi = async () => {
      try {
        if (!isFieldDisabled && urlConfigParsed) {
          setApiIsLoading(true);

          await loadUrlOptions(urlConfigParsed, isFieldDisabled);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setApiIsLoading(false);
      }
    };

    fetchApi();
  }, [isFieldDisabled, urlConfigParsed]);

  const loadUrlOptions = async (urlEnumOptions) => {
    try {
      const json = await fetch(urlEnumOptions, {
        method: "GET",
        mode: "cors",
      }).then((response) => response.json());

      setUrlOptions(json);
    } catch (error) {
      console.log(error);
    }
  };

  const getObjectPropertie = (fieldProperties, id) => {
    const model =
      fieldProperties &&
      _.find(fieldProperties, function (a) {
        return a.id === id;
      });
    return model;
  };

  const {
    showValidate,
    error,
    value,
    placeholder,
    readOnly,
    className,
    toolTip,
    style,
    options,
    fullWidth,
  } = props;

  const id = fieldProperties && fieldProperties.id;

  const label = getUnitPropertie(fieldProperties, "label");
  const isRequired = getUnitPropertie(fieldProperties, "isRequired");
  let _options = [];
  if (options) {
    options.map((option) => {
      return _options.push(
        <MenuItem key={option.value} value={option.value}>
          {option.text}
        </MenuItem>,
      );
    });
  } else {
    const objeto = getObjectPropertie(
      props.fieldProperties.properties,
      "options",
    );
    _options = getOptions(objeto);
  }

  let fixWidth;

  !fullWidth && (fixWidth = { width: "35%" });

  return (
    <TaskToolTip title={toolTip}>
      <FormControl
        key={"divPadrao" + id}
        margin="normal"
        fullWidth={fullWidth}
        style={fixWidth}
      >
        <InputLabel htmlFor={label} required={isRequired}>
          {label}
        </InputLabel>
        {showValidate && error ? (
          <Select
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            error={!!error}
            key={"select" + id}
            value={value || ""}
            placeholder={placeholder || ""}
            readOnly={readOnly || false}
            className={className}
            style={style}
            disabled={apiIsLoading || isFieldDisabled}
            startAdornment={
              apiIsLoading ? <CircularProgress size={20} /> : null
            }
          >
            {_options}
          </Select>
        ) : (
          <Select
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            error={undefined}
            key={"select" + id}
            value={value || ""}
            placeholder={placeholder}
            readOnly={readOnly}
            className={className}
            style={style}
            disabled={apiIsLoading || isFieldDisabled}
            startAdornment={
              apiIsLoading ? <CircularProgress size={20} /> : null
            }
          >
            {_options}
          </Select>
        )}

        {showValidate && error && <HelperText>{error}</HelperText>}
      </FormControl>
    </TaskToolTip>
  );
}

// const mapStateToProps = createStructuredSelector({
//   urloptions: selectEnumOption,
//   value: (state, props) => selectFilterFormValuesSelector(state, props.id),
// });
//
// const mapDispatchToProps = {
//   fetchEnumOptions,
// };

export default TaskFieldSelect;
